import CyclingCache from "../cache/CyclingCache";
import LightSource from "./LightSource";

export default class LightSourceCache extends CyclingCache {
    constructor() {
        super();
    }

    /**
     * @returns {number}
     */
    getGrowAmount() {
        return 5;
    }

    /**
     * @returns {number}
     */
    getInitialSize() {
        return 5;
    }

    /**
     * @override
     * @returns {LightSource}
     */
    createInstance() {
        return new LightSource();
    }
}